import React from 'react';
import './App.css';
import { HashRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import News from './pages/News';
import NewsDetail from './pages/NewsDetail';
import Leadership from './pages/Leadership';
import Lpttn from './pages/Lpttn';
import Admin from './pages/Admin';
import Layout from './components/layout/Layout';
import { LanguageProvider } from './i18n/LanguageContext';

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <HashRouter>
          <Routes>
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/tentang" element={<About />} />
                  <Route path="/berita" element={<News />} />
                  <Route path="/berita/:slug" element={<NewsDetail />} />
                  <Route path="/pimpinan" element={<Leadership />} />
                  <Route path="/lpttn" element={<Lpttn />} />
                </Routes>
              </Layout>
            } />
          </Routes>
        </HashRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
